export default __webpack_public_path__ + "static/media/P306.1.e4e39450.mp3";